export class Table {
    constructor(id, round, seats) {
        this.id = id;
        this.round = round;
        this.seats = seats;
    }
}